export default __webpack_public_path__ + "static/media/header-frame.1fff0525.png";